global.$ = global.jQuery = require('jquery');

import * as bootstrap from 'bootstrap';
window.bootstrap = bootstrap;

import Headroom from "headroom.js";

import AOS from 'aos';
import 'aos/dist/aos.css';

import Swiper from 'swiper/bundle';
import 'swiper/css/bundle';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
window.Swiper = Swiper;

$(document).ready(function() {

    // To-top button
    const toTopBtn = $('#to-top');
    $(window).scroll(function(){
        if ($(window).scrollTop() > 300) {
            toTopBtn.fadeIn();
        } else {
            toTopBtn.fadeOut();
        }
    });

    toTopBtn.on('click', function (e) {
        e.preventDefault();
        $('html, body').animate({
            scrollTop: 0
        }, 'slow');
    });
    // sticky scroll menu
    const header = $('header');
    let offSet = $('.home-swiper').innerHeight()
    let fromTop = ($(window).scrollTop())
    let beforeAfterImg =$('.box-before-after .img');
    beforeAfterImg.css('background-size' , $(".box-before-after").width()+'px')
    function updateHeaderHeight() {
        document.documentElement.style.setProperty('--header-height', $('header').outerHeight() + 'px');
    }
    updateHeaderHeight();

    window.onresize = function() {
        offSet = $('.home-swiper').innerHeight()
        beforeAfterImg.css('background-size' , $(".box-before-after").width()+'px')
        updateHeaderHeight()
        setHead()
    }

    setHead()
    function setHead(){
        header.removeClass('header--std');
        if (header.attr('data-type') === 'header--home') {
            if (fromTop >= offSet){
                header.removeClass(header.attr('data-type'));
            } else {
                header.addClass(header.attr('data-type'));
            }
            window.onscroll = function () {
                fromTop = ($(window).scrollTop())
                if (fromTop === 0) {
                    header.addClass(header.attr('data-type'));
                    header.removeClass('header--std');
                } else {
                    header.removeClass(header.attr('data-type'));
                    header.addClass('header--std');
                }
            };
        } else {
            header.addClass('header--std');
        }
    }

    if($('.headroom').length > 0){
        let headroomEl = document.querySelector("header");
        let options = {
            offset : 100,
        }
        let headroom  = new Headroom(headroomEl,options);
        headroom.init();
    }

    AOS.init({
        delay: 400,
        duration: 800,
        once: true,
    });


    if ($(".swiperHomeMain").length > 0){
        const swiper = new Swiper('.swiperHomeMain', {
            // Parametri base
            loop: true, // ciclo continuo
            speed: 800,
            autoplay: {
                delay: 5000, // 5 secondi per slide
                disableOnInteraction: false,
            },
            // Paginazione
            pagination: {
                el: '.swiper-pagination',
                clickable: true,
                bulletClass: "swiper-home-bullet"
            },
            // Navigazione
            navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
                addIcons: false,
            },
            // Effetto
            effect: 'slide', // puoi provare anche 'fade', 'cube', ecc.
        });
    }

    if ($(".swiperNews").length > 0) {
        new Swiper('.swiperNews', {
            loop: true,
            slidesPerView: 1,
            effect: 'fade',
            fadeEffect: { crossFade: true },
            speed: 500,
            pagination: {
                el: '.swiper-pagination-news',
                clickable: true,
                bulletClass: 'swiper-home-bullet',
            },
            navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
                addIcons: false,
            },
            keyboard: { enabled: true },
        });
    }

    if ($(".swiperNewsHome").length > 0){
        const slides = [...document.querySelectorAll('.swiperNewsHome .swiper-slide')].map(el => ({
            img:   el.querySelector('img').src,
            title: el.querySelector('h4').textContent,
            desc:  el.querySelector('p').textContent,
        }));

        const n = slides.length;
        let current = 1; // indice reale della slide centrale
        let transitioning = false;

        function positionNewsPagination() {
            const pagination = document.querySelector('.swiper-pagination-news');
            const swiperEl = document.querySelector('.swiperNewsHome');
            if (!pagination || !swiperEl) return;

            if (window.innerWidth >= 992) {
                pagination.style.top = '';
                pagination.style.bottom = '';
                return;
            }

            const slideEls = swiperEl.querySelectorAll('.swiper-slide');
            let maxHeight = 0;
            slideEls.forEach(slide => {
                if (slide.offsetHeight > maxHeight) maxHeight = slide.offsetHeight;
            });

            pagination.style.bottom = 'auto';
            pagination.style.top = (swiperEl.offsetTop + maxHeight + 16) + 'px';
        }

        const swiper = new Swiper('.swiperNewsHome', {
            effect: 'coverflow',
            grabCursor: true,
            centeredSlides: true,
            loop: true,
            loopedSlides: 4,
            slidesPerView: 'auto',
            coverflowEffect: {
                rotate: 0,
                stretch: 0,
                depth: 50,
                modifier: 2.5,
                scale: 0.98,
                slideShadows: false,
            },
            pagination: {
                el: '.swiper-pagination-news',
                clickable: true,
                bulletClass: "swiper-home-bullet"
            },
            navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
                addIcons: false,
            },
            keyboard: { enabled: true },
            // autoplay: {
            //     delay: 3500,
            //     disableOnInteraction: false,
            //     pauseOnMouseEnter: true,
            // },
            autoplay: false,
            speed: 500,
        });

        swiper.on('slideChangeTransitionEnd', positionNewsPagination);
        window.addEventListener('resize', positionNewsPagination);
        setTimeout(positionNewsPagination, 100);

        // function updateSlides(centerIdx) {
        //     const prev = (centerIdx - 1 + n) % n;
        //     const next = (centerIdx + 1) % n;
        //     const order = [prev, centerIdx, next];
        //
        //     document.querySelectorAll('.swiper-slide').forEach((el, i) => {
        //         const d = slides[order[i]];
        //         el.querySelector('img').src = d.img;
        //         el.querySelector('img').alt = d.title;
        //         el.querySelector('h2').textContent = d.title;
        //         el.querySelector('p').textContent = d.desc;
        //     });
        // }
        //
        // // Al cambio slide, se si va all'estremo reimposta il contenuto e torna alla slide centrale (1) senza animazione
        // swiper.on('slideChangeTransitionEnd', () => {
        //     const idx = swiper.activeIndex; // 0, 1 o 2
        //
        //     if (idx === 1) return; // slide centrale, niente da fare
        //
        //     // Aggiorna l'indice reale
        //     if (idx === 2) current = (current + 1) % n;
        //     if (idx === 0) current = (current - 1 + n) % n;
        //
        //     updateSlides(current);
        //
        //     // Torna silenziosamente alla slide centrale
        //     swiper.slideTo(1, 0, false);
        // });
        //
        // // Init
        // updateSlides(current);
    }

    const currentPath = window.location.pathname;

    // Popola il pannello mobile sedi dagli item del desktop
    $('#menu .menu-item-sede').each(function () {
        const $a = $(this).children('a').first();
        const href = $a.attr('href');
        const title = $a.text().trim();
        if (href && title) {
            const isActive = href && currentPath === new URL(href, window.location.origin).pathname;
            $('#menu-mobile-sedi-items').append(
                `<div class="menu-mobile__service-item${isActive ? ' active' : ''}"><a href="${href}">${title}</a></div>`
            );
        }
    });

    // Popola il pannello mobile servizi dal primo #header-link-servizi (desktop)
    $('#header-link-servizi').first().find('.container .row > div').each(function () {
        const $link = $(this).find('a').first();
        const href = $link.attr('href');
        const title = $link.find('p').first().text().trim();
        if (href && title) {
            const isActive = href && currentPath === new URL(href, window.location.origin).pathname;
            $('#menu-mobile-servizi-items').append(
                `<div class="menu-mobile__service-item${isActive ? ' active' : ''}"><a href="${href}">${title}</a></div>`
            );
        }
    });

    // Aggiungi link "Tutti i servizi" in fondo al pannello mobile
    const serviziUrl = $('.menu-item-servizi > a').attr('href');
    if (serviziUrl) {
        $('#menu-mobile-servizi-items').append(
            `<div class="menu-mobile__service-item menu-mobile__service-item--all"><a href="${serviziUrl}">Tutti i servizi</a></div>`
        );
    }

    // Sposta solo il submenu servizi nel body (full-width, evita interferenze con il transform di headroom)
    $('body').append($('#header-link-servizi').detach());

    // Mobile menu
    $('body').append($('#menu-mobile').detach());

    $('#menu-mobile-open').on('click', function () {
        const $btn = $(this);
        const $menu = $('#menu-mobile');
        const $icon = $btn.find('i');

        if ($menu.hasClass('is-open')) {
            $menu.removeClass('is-open');
            $btn.removeClass('is-open');
            $icon.removeClass('bi-x-lg').addClass('bi-list');
            header.removeClass('header--mobile-open');
            setTimeout(function () {
                $('body').removeClass('overflow-hidden');
            }, 650);
        } else {
            $menu.addClass('is-open');
            $btn.addClass('is-open');
            $icon.removeClass('bi-list').addClass('bi-x-lg');
            header.addClass('header--mobile-open');
            $('body').addClass('overflow-hidden');
        }
    });

    // Pannello servizi mobile
    $('#menu-mobile').on('click', '.menu-item-servizi', function (e) {
        e.preventDefault();
        $('#menu-mobile-panel-servizi').addClass('is-open');
    });

    $('#menu-mobile-back-servizi').on('click', function () {
        $('#menu-mobile-panel-servizi').removeClass('is-open');
    });

    // Submenu accordion nel menu mobile (escluso menu-item-servizi che usa il pannello)
    $('#menu-mobile').on('click', '.header__item-has-submenu:not(.menu-item-servizi) > a, .header__item-has-submenu:not(.menu-item-servizi) > span', function (e) {
        const $item = $(this).closest('.header__item-has-submenu');
        const $wrapper = $item.children('.header__nav-submenu-wrapper');
        if ($wrapper.length) {
            e.preventDefault();
            if ($item.hasClass('open')) {
                $item.removeClass('open');
                $wrapper.stop().slideUp(500);
            } else {
                $item.addClass('open');
                $wrapper.stop().slideDown(500);
            }
        }
    });

    // Pannello sedi mobile
    $('#menu-mobile-sedi-trigger').on('click', function () {
        $('#menu-mobile-panel-sedi').addClass('is-open');
    });

    $('#menu-mobile-back-sedi').on('click', function () {
        $('#menu-mobile-panel-sedi').removeClass('is-open');
    });

    let linkColl = $(".link-sedi");
    let linkColleSer = $(".link-servizi");
    let linkCollA = $(".link-sedi a");
    let linkCollASer = $(".link-servizi a");
    let contCollDesk = $("#header-link-sede");
    let contCollDeskSer = $("#header-link-servizi");

    openCloseSubMenu(linkColl, linkCollA, contCollDesk, false)
    openCloseSubMenu(linkColleSer, linkCollASer, contCollDeskSer, false)

    function openCloseSubMenu(link, linka, sub, preventClick) {
        if (preventClick) {
            link.click(function (e) {
                e.preventDefault();
            });
        }

        link.hover(function (e) {
            sub.stop().slideDown(400);
            sub.addClass('open')
            e.stopPropagation()
        }, function (e) {
            sub.stop().slideUp(400);
            sub.removeClass('open')
            e.stopPropagation()
        });

        sub.hover(function (e) {
            sub.stop().slideDown(400);
            e.stopPropagation()
        }, function (e) {
            sub.stop().slideUp(400);
            e.stopPropagation()
        });
    }

    let mobileFooterOpener = $('#mobileFooterOpener')
    let footerInfos = $('#footerInfos')

    mobileFooterOpener.click(function (e) {
        e.preventDefault()
        if (mobileFooterOpener.hasClass('open')) {
            footerInfos.stop().slideUp(500);
            mobileFooterOpener.removeClass('open')
        } else {
            footerInfos.stop().slideDown(500);
            mobileFooterOpener.addClass('open')
            let n = $(document).height();
            // console.log(n)
            $('html, body').animate({scrollTop: n}, 200);
        }
    })
});
